// src/components/FormularioCambioAlmacen.js
import React, { useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import './FormularioCambioAlmacen.css';

const FormularioCambioAlmacen = ({ botella, onClose, onGuardar, apiUrl }) => {
  const [usuarios, setUsuarios] = useState([]);
  const [nuevoAlmacen, setNuevoAlmacen] = useState('');
  const API_URL = process.env.REACT_APP_API_URL || '';

  useEffect(() => {
    fetch(`${API_URL}/api/usuariosgas`)
      .then(res => res.json())
      .then(data => {
        if (Array.isArray(data)) {
          const filtrados = data.filter(u => u.tipo === 100 || u.tipo === 485);
          setUsuarios(filtrados);
        } else {
          toast.error('Error inesperado al cargar usuarios gas');
        }
      })
      .catch(err => {
        console.error(err);
        toast.error('Error cargando usuarios gas');
      });
  }, [apiUrl]);
  
  

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const res = await fetch(`${API_URL}/api/gas/almacen/${botella.id}`, {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ nuevoAlmacen })
      });

      if (res.ok) {
        toast.success('Almacén actualizado');
        onGuardar(true);
      } else {
        toast.error('Error al actualizar almacén');
      }
    } catch (err) {
      toast.error('Error en la petición');
    }
  };

  return (
    <div className="modal-overlay">
      <div className="modal">
        <h3>Cambiar almacén de la botella</h3>
        <p><strong>ID:</strong> {botella.id}</p>
        <p><strong>Tipo Gas:</strong> {botella.tipoGas}</p>

        <form onSubmit={handleSubmit}>
          <label>Nuevo almacén:</label>
          <select value={nuevoAlmacen} onChange={e => setNuevoAlmacen(e.target.value)} required>
            <option value="">-- Selecciona --</option>
            {usuarios.map(u => (
              <option key={u.id} value={u.nombre}>{u.nombre}</option>
            ))}
          </select>

          <div className="modal-buttons">
            <button type="submit">Guardar</button>
            <button type="button" onClick={onClose}>Cancelar</button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default FormularioCambioAlmacen;
